import { render } from "./userCompetition.vue?vue&type=template&id=3b578442&scoped=true"
import script from "./userCompetition.vue?vue&type=script&lang=js"
export * from "./userCompetition.vue?vue&type=script&lang=js"

import "./userCompetition.vue?vue&type=style&index=0&id=3b578442&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b578442"]])

export default __exports__